export default "__VITE_ASSET__BMOScRAC__"